module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-2 28H12V4h16v24zM15.05 18H20v3.438c0 .6.424.742.87.316l4.814-4.986c.446-.424.386-1.112-.054-1.538l-4.732-4.986c-.446-.424-.898-.284-.898.318V14h-4.95c-.552 0-1.05.446-1.05 1v2c0 .55.498 1 1.05 1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/slide-in-right-1.js
// module id = 1417
// module chunks = 14